import {CompanyNewsTile} from "@irati/types"

const companyNewsToRows = (companyNews: CompanyNewsTile[]): CompanyNewsTile[][] => {
  const xposArr: number[] = []

  companyNews.map((c) => {
    if (!xposArr.includes(c.xpos)) {
      xposArr.push(c.xpos)
    }
  })

  return xposArr.sort().map((i) => {
    return companyNews.filter((c) => c.xpos === i)
  })
}

export default companyNewsToRows
